import React from 'react';
import swal from 'sweetalert';
import { GridCell } from '@progress/kendo-react-grid';
import { Component } from 'react';

class BatchDelete extends Component {
	constructor(props) {
		super(props);
		this.state = {
			batchInEdit: this.props.dataItem || null,
			batchStatus: this.props.dataItem.BatchJobId ? this.props.dataItem.BatchStatus.name : null,
			batchStatuses: this.props.batchStatuses
		};
	}

	cancel = () => {

	}

	render() {
		return (
			<div>
				{console.log(this.state.batchStatus)}
				{this.state.batchInEdit.BatchJobId && this.state.batchStatus == "Open" ? 
					this.state.batchInEdit.IsAssignedToAtLeastOneTransaction != true ?
					<button
						className="admin-k-button "
						onClick={(event) => {
							event.preventDefault();
							swal({
								text: `Warning: Are you sure you want to delete this batch? This batch will not be recoverable.`
								,
								icon: 'warning',
								buttons: {
									cancel: 'NO',
									confirm: 'YES'
								},
								dangerMode: true
							}).then((value) => (value ? this.props.deleteBatch(this.props.dataItem) : null));
						}}
					>
						DELETE
					</button>	
						:
						<button
							className="admin-k-button "
							onClick={(event) => {
								event.preventDefault();
								swal({
									text: `Warning: Cannot delete a batch that has one or more transactions assigned to it. Please remove all transactions from this batch, in order to delete it.`
									,
									icon: 'warning',
									buttons: {
										confirm: 'OK'
									},
									dangerMode: true
								}).then(() => this.cancel);
							}}
						>
							DELETE
					</button>	
						:""}
			</div>
		);
	};
}

export default BatchDelete;